module.exports = __webpack_public_path__ + "static/image/icon-switch.svg?57f66eff830c34dc19f3b445f766b678";